// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Belt_List from "../../../../../../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as Caml_format from "../../../../../../../../../../node_modules/rescript/lib/es6/caml_format.js";

function getPercentage(endId, startId) {
  if (endId === undefined) {
    return "";
  }
  if (startId === undefined) {
    return "";
  }
  var match = endId.length;
  var match$1 = startId.length;
  if (match === 0) {
    return "";
  }
  if (match$1 === 0) {
    return "";
  }
  var end = Caml_format.caml_int_of_string(endId);
  var start = Caml_format.caml_int_of_string(startId);
  if (start < 0 || end < 0 || start > 99 || end > 99 || end < start) {
    return "Invalid";
  } else {
    return String((end - start | 0) + 1 | 0) + "%";
  }
}

function checkForOverlap(test_id_range) {
  var sorted_id_range = Belt_List.toArray(List.sort((function (a, b) {
              return Caml_format.caml_int_of_string(a.start) - Caml_format.caml_int_of_string(b.start) | 0;
            }), test_id_range));
  var start = {
    contents: -1
  };
  var result = {
    contents: true
  };
  sorted_id_range.forEach(function (item) {
        if (start.contents >= Caml_format.caml_int_of_string(item.start)) {
          result.contents = false;
        }
        start.contents = Caml_format.caml_int_of_string(item.end);
        
      });
  return !result.contents;
}

function validIdRangeSum(test_id_range) {
  var sum = Belt_List.reduce(test_id_range, 0, (function (acc, id) {
          return (acc + (Caml_format.caml_int_of_string(id.end) - Caml_format.caml_int_of_string(id.start) | 0) | 0) + 1 | 0;
        }));
  return sum < 100;
}

function removeNonNumericValue(value) {
  return value.replace(/\D/g, "");
}

function getIdRange(start, end) {
  if (start === undefined) {
    return ;
  }
  if (end === undefined) {
    return ;
  }
  var match = start.length;
  var match$1 = end.length;
  if (match !== 0 && match$1 !== 0) {
    return {
            start: start,
            end: end
          };
  }
  
}

function generateList(test_groups, test_1_start, test_1_end, test_2_start, test_2_end, test_3_start, test_3_end, test_4_start, test_4_end) {
  var result = /* [] */0;
  if (test_groups >= 1) {
    var node = getIdRange(test_1_start, test_1_end);
    result = node !== undefined ? Belt_List.add(result, node) : result;
  }
  if (test_groups >= 2) {
    var node$1 = getIdRange(test_2_start, test_2_end);
    result = node$1 !== undefined ? Belt_List.add(result, node$1) : result;
  }
  if (test_groups >= 3) {
    var node$2 = getIdRange(test_3_start, test_3_end);
    result = node$2 !== undefined ? Belt_List.add(result, node$2) : result;
  }
  if (test_groups >= 4) {
    var node$3 = getIdRange(test_4_start, test_4_end);
    result = node$3 !== undefined ? Belt_List.add(result, node$3) : result;
  }
  return result;
}

function startIdValidator(test_start) {
  if (test_start === undefined) {
    return {
            TAG: /* Error */1,
            _0: "Start ID required"
          };
  }
  if (test_start.length === 0) {
    return {
            TAG: /* Error */1,
            _0: "Start ID required"
          };
  }
  var startId = Caml_format.caml_int_of_string(test_start);
  if (startId < 0 || startId > 99) {
    return {
            TAG: /* Error */1,
            _0: "Start ID out of range, valid range [00-99]"
          };
  } else {
    return {
            TAG: /* Ok */0,
            _0: test_start
          };
  }
}

function endIdValidator(test_start, test_end) {
  if (test_start === undefined) {
    if (test_end !== undefined) {
      return {
              TAG: /* Error */1,
              _0: "Plese enter start ID first"
            };
    } else {
      return {
              TAG: /* Error */1,
              _0: "End ID required"
            };
    }
  }
  if (test_end === undefined) {
    return {
            TAG: /* Error */1,
            _0: "End ID required"
          };
  }
  var match = test_start.length;
  var match$1 = test_end.length;
  if (match === 0) {
    return {
            TAG: /* Error */1,
            _0: "Plese enter start ID first"
          };
  }
  if (match$1 === 0) {
    return {
            TAG: /* Error */1,
            _0: "End ID required"
          };
  }
  var startId = Caml_format.caml_int_of_string(test_start);
  var endId = Caml_format.caml_int_of_string(test_end);
  if (endId < 0 || endId > 99) {
    return {
            TAG: /* Error */1,
            _0: "End ID out of range, valid range [00-99]"
          };
  } else if (startId > endId) {
    return {
            TAG: /* Error */1,
            _0: "Start ID Cannot be greater than End Id"
          };
  } else {
    return {
            TAG: /* Ok */0,
            _0: test_end
          };
  }
}

export {
  getPercentage ,
  checkForOverlap ,
  validIdRangeSum ,
  removeNonNumericValue ,
  getIdRange ,
  generateList ,
  startIdValidator ,
  endIdValidator ,
  
}
/* No side effect */
